import { render } from "./SwitchLoanTypeContent.vue?vue&type=template&id=0b710f78"
import script from "./SwitchLoanTypeContent.vue?vue&type=script&lang=js"
export * from "./SwitchLoanTypeContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__